import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
//     //Participant/Merge/{AuthToken}/{SourceParticipantGuid}/{TargetParticipantGuid}/
export const fetchParticipantMerges = createAsyncThunk('participantmerge/get', async (incomingVariable, thunkAPI) => {

    try {
        const response = await axios.post(PLATFORM + "Participant/Merge/" + incomingVariable.authToken + "/" + incomingVariable.ParticipantId_Guid_From + "/"+ incomingVariable.ParticipantId_Guid_To + "/")
        const data = await response.data

        return data
    } catch (err) {

        return thunkAPI.rejectWithValue({ error: err.message });
    }
})



const participantmergeSlice = createSlice({
    name: 'participantmerges',
    initialState,
    reducers: {
        participantmergeClear(state, action) {
            state.entities = initialState.entities
            state.status = "idle"
            state.error = null
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchParticipantMerges.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchParticipantMerges.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success===true){

                    state.status = 'success'
                    const loadedData = action.payload.Info
                    
                    const data = {}
                    for (var i = 0; i < loadedData.length; i++) {
                        const partObject = loadedData[i]
                        data[partObject.Invite] = partObject
                    }
                    state.entities = data
                } else {
                    state.status = "failed"
                    state.error = action.payload.Status[0]
                }
            })
            .addCase(fetchParticipantMerges.rejected, (state, action) => {
                state.error = action.error.message
                state.status = "failed"
            })
            
    }
})

export const { participantmergeClear } = participantmergeSlice.actions

export default participantmergeSlice.reducer

const selectParticipantMergesEntities = (state) => state.participantmerges.entities

export const selectParticipantMerges = createSelector(selectParticipantMergesEntities, (entities) =>
    Object.values(entities)
)

export const selectParticipantMergesById = (state, ParticipantMergesId) => {
    return selectParticipantMergesEntities(state)[ParticipantMergesId]
}
